import { FC, Dispatch, SetStateAction } from "react";
import Descriptions from "./LaborCategoryDescriptions.json";

interface ICollapsables {
  information_for_ordering_offices: boolean;
  terms_and_conditions: boolean;
  labor_category_descriptions: boolean;
  labor_rates: boolean;
}

interface IProps {
  isCollapsed: ICollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ICollapsables>>;
}

function toCurrency(number: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(number);
}

export const LaborRates: FC<IProps> = ({ isCollapsed, setIsCollapsed }) => {
  let { labor_categories } = Descriptions;
  let management: any = [];
  let infoSys: any = [];
  let training: any = [];
  let network: any = [];
  let support: any = [];

  labor_categories.forEach((category: any) => {
    switch (category.division) {
      case "Management":
        management.push(category);
        break;
      case "Information Systems":
        infoSys.push(category);
        break;
      case "Training & Training Development":
        training.push(category);
        break;
      case "Networks & Telecommunications":
        network.push(category);
        break;
      case "Support Functions":
        support.push(category);
        break;
      default:
        break;
    }
  });
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            labor_rates: !isCollapsed.labor_rates,
          })
        }
        className="collapsable"
      >
        Labor Rates
        <i
          className={
            isCollapsed.labor_rates ? "fas fa-caret-down" : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.labor_rates ? "hidden" : ""
        }`}
      >
        <div className="collapse-wrapper">
          <button
            onClick={() =>
              setIsCollapsed({
                ...isCollapsed,
                labor_rates: true,
              })
            }
            className="collapse-section"
          >
            Collapse section
          </button>
        </div>
        <div className="general_info">
          <span>GSA Contract Number - GS-35F-068GA</span>
          <span>Professional Software Engineering, Inc. (t/a PROSOFT)</span>
          <div className="general_info__contact">
            <span>500 Viking Drive, Suite 301</span>
            <span>Virginia Beach, VA 23452-7477</span>
            <span>(757) 431-2400</span>
          </div>
          <span className="general_info__subheader">SERVICES PRICE LIST</span>
        </div>
        <div className="notice">
          <p className="text-center">Effective November 15, 2017 forward</p>
          <div className="table">
            <div className="table__header">
              <p>Management</p>
              <p>GSA Price</p>
            </div>
            <div className="table__info">
              {management.map((position: any) => {
                return (
                  <div className="table__info__row">
                    <p>{position.position}</p>
                    <p>{toCurrency(position.gsa_price)}</p>
                  </div>
                );
              })}
            </div>
            <div className="table__header">
              <p>Information Systems</p>
              <p>-</p>
            </div>
            <div className="table__info">
              {infoSys.map((position: any) => {
                return (
                  <div className="table__info__row">
                    <p>{position.position}</p>
                    <p>{toCurrency(position.gsa_price)}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="table__header">
            <p>Training & Training Development</p>
            <p>-</p>
          </div>
          <div className="table__info">
            {training.map((position: any) => {
              return (
                <div className="table__info__row">
                  <p>{position.position}</p>
                  <p>{toCurrency(position.gsa_price)}</p>
                </div>
              );
            })}
          </div>
          <div className="table__header">
            <p>Networks & Telecommunications</p>
            <p>-</p>
          </div>
          <div className="table__info">
            {training.map((position: any) => {
              return (
                <div className="table__info__row">
                  <p>{position.position}</p>
                  <p>{toCurrency(position.gsa_price)}</p>
                </div>
              );
            })}
          </div>
          <div className="table__header">
            <p>Support Functions</p>
            <p>-</p>
          </div>
          <div className="table__info">
            {support.map((position: any) => {
              return (
                <div className="table__info__row">
                  <p>{position.position}</p>
                  <p>{toCurrency(position.gsa_price)}</p>
                </div>
              );
            })}
          </div>
          <div className="table__info">
            <small>
              Pricelist current through Contract Modification No. PO-0002 dated
              November 15, 2017
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};
